/**
 * =============================================================================
 * SCRIPT-NAME:   App.js
 * PROJEKT:       Freiseinapp - Haupt-Router
 * VERSION:       v1.i23
 * DATUM:         2026-03-13
 * AENDERUNGEN v1.i23:
 * - SosToolkitPlayer Import + Route hinzugefügt (/sos-toolkit)
 * =============================================================================
 */

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AdminDashboard from "./components/AdminDashboard";
import Contacts from "./components/Contacts";
import Conversions from "./components/Conversions";
import ClientDashboard from "./components/ClientDashboard";
import ClientCoaching from "./components/ClientCoaching";
import TestDashboard from "./components/TestDashboard";
import Register from "./components/Register";
import SetPassword from "./components/SetPassword";
import AdminFreischaltung from "./components/AdminFreischaltung";
import AnalyticsDashboard from "./components/AnalyticsDashboard";
import SendEmail from "./components/SendEmail";
import SpeedTest from "./components/SpeedTest";
import KdiTracker from "./components/kdi_tracker";
import UserJourneyExplorer from "./components/uje_UserJourneyExplorer";

// --- IMPORTE FUER DAS ADS-MANAGEMENT ---
import AdsKeywordManager from "./components/AdsKeywordManager";
import AdsPerfDashboard from "./components/AdsPerfDashboard";

// --- IMPORTE FUER DAS SOS TOOLKIT ---
import SosToolkitPlayer from "./components/SosToolkitPlayer";

// --- IMPORTE FUER DAS GSC KPI-DASHBOARD ---
import GscKpi from "./components/gsc_kpi";

function App() {
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  // eslint-disable-next-line no-unused-vars
  const [role, setRole] = useState(localStorage.getItem("role") || "");

  const ProtectedRoute = ({ element, allowedRoles }) => {
    const currentToken = localStorage.getItem("token");
    const currentRole  = localStorage.getItem("role");
    if (!currentToken || !allowedRoles.includes(currentRole)) {
      return <Navigate to="/" replace />;
    }
    return element;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login setRole={setRole} setToken={setToken} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/neu-anmelden" element={<Register />} />
        <Route path="/set-password" element={<SetPassword />} />

        <Route path="/admin" element={<ProtectedRoute element={<AdminDashboard />} allowedRoles={["admin"]} />} />
        <Route path="/contacts" element={<ProtectedRoute element={<Contacts />} allowedRoles={["admin"]} />} />
        <Route path="/conversions" element={<ProtectedRoute element={<Conversions />} allowedRoles={["admin"]} />} />
        <Route path="/admin-freischaltung" element={<ProtectedRoute element={<AdminFreischaltung />} allowedRoles={["admin"]} />} />
        <Route path="/analytics" element={<ProtectedRoute element={<AnalyticsDashboard />} allowedRoles={["admin"]} />} />
        <Route path="/send-email" element={<ProtectedRoute element={<SendEmail />} allowedRoles={["admin"]} />} />
        <Route path="/speed-test" element={<ProtectedRoute element={<SpeedTest />} allowedRoles={["admin"]} />} />
        <Route path="/kdi-tracker" element={<ProtectedRoute element={<KdiTracker />} allowedRoles={["admin"]} />} />
        <Route path="/user-journey" element={<ProtectedRoute element={<UserJourneyExplorer />} allowedRoles={["admin"]} />} />

        {/* ADS MANAGEMENT */}
        <Route path="/ads-keywords" element={<ProtectedRoute element={<AdsKeywordManager />} allowedRoles={["admin"]} />} />
        <Route path="/ads-perf"     element={<ProtectedRoute element={<AdsPerfDashboard />}  allowedRoles={["admin"]} />} />

        {/* SOS TOOLKIT */}
        <Route path="/sos-toolkit"  element={<ProtectedRoute element={<SosToolkitPlayer />}  allowedRoles={["client", "admin"]} />} />

        {/* GSC KPI-DASHBOARD */}
        <Route path="/gsc-kpi"      element={<ProtectedRoute element={<GscKpi />}            allowedRoles={["admin"]} />} />

        <Route path="/client-dashboard" element={<ProtectedRoute element={<ClientDashboard />} allowedRoles={["client", "admin"]} />} />
        <Route path="/client-coaching" element={<ProtectedRoute element={<ClientCoaching useClientAPI={true} />} allowedRoles={["client", "admin"]} />} />
        <Route path="/client-coaching/:tabellenname" element={<ProtectedRoute element={<ClientCoaching useClientAPI={true} />} allowedRoles={["client", "admin"]} />} />
        <Route path="/test-dashboard" element={<ProtectedRoute element={<TestDashboard />} allowedRoles={["test", "admin"]} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;